/** Canonical URL for a custom-agent run on the `/runs` page. */
export function runPageHref(type: 'custom', runId: string): string {
  return `/runs?${new URLSearchParams({ type, run: runId }).toString()}`
}

/** Canonical URL for a custom-agent config on the Configure page. */
export function customAgentConfigHref(configId: string): string {
  return `/configure?type=custom&id=${encodeURIComponent(configId)}`
}

/** Top-level Problems page (plant managers' work page). */
export const PROBLEMS_PATH = '/problems'
export const PROBLEM_QUERY_PARAM = 'problem'
export const PROBLEMS_SCOPE_QUERY_PARAM = 'scope'

/** Canonical URL for the Problems page, optionally selecting one problem. */
export function problemsHref(problemId?: string, scope?: 'open' | 'all'): string {
  const params = new URLSearchParams()
  if (problemId) params.set(PROBLEM_QUERY_PARAM, problemId)
  if (scope === 'all') params.set(PROBLEMS_SCOPE_QUERY_PARAM, scope)
  const query = params.toString()
  return query ? `${PROBLEMS_PATH}?${query}` : PROBLEMS_PATH
}

/** Top-level Tasks page (technicians' and engineers' work page). */
export const TASKS_PATH = '/tasks'
export const TASK_QUERY_PARAM = 'task'

/** Legacy result-item link. Canonical tasks use problemTaskHref. */
export function tasksHref(taskId?: string): string {
  if (!taskId) return TASKS_PATH
  return `${TASKS_PATH}?${new URLSearchParams({ [TASK_QUERY_PARAM]: taskId }).toString()}`
}

/** Legacy deep link to a problem on the list; redirects to its own page. */
export const OCCURRENCE_QUERY_PARAM = 'problem_occurrence_id'
/** Names the running investigation whose unpublished problem a page shows. */
export const PROBLEM_RUN_QUERY_PARAM = 'run'
/** A problem's own page. A draft carries the run that is still investigating it. */
export function occurrenceHref(id: string, runId?: string): string {
  const page = `${PROBLEMS_PATH}/${encodeURIComponent(id)}`
  return runId ? `${page}?${new URLSearchParams({ [PROBLEM_RUN_QUERY_PARAM]: runId })}` : page
}

export const PROBLEM_TASK_QUERY_PARAM = 'problem_task_id'
export function problemTaskHref(id: string): string {
  return `${TASKS_PATH}?${new URLSearchParams({ [PROBLEM_TASK_QUERY_PARAM]: id })}`
}
